module.exports = __webpack_public_path__ + "img/satelite.9ca32951.svg";